<template>
    <div class="error_messages" v-if="errors.length">
        <div class="error_message" v-for="error in errors" :key="error">{{$t(error)}}</div>
    </div>
</template>

<style>
    div.error_messages {
        padding-bottom: 30px;
    }
    .error_message {
        color: #ff0031;
        padding-bottom: 10px;
    }
</style>

<script>
    export default {
        props: ['errors']
    }
</script>
